const selectMenuStyles = {
    menu: (base) => ({
        ...base,
        zIndex: 9999,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999
    }),

}
export default selectMenuStyles